define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/SupplierModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext, SupplierModel) {
    "use strict";
    var Suppliers = /** @class */ (function () {
        function Suppliers() {
            this.userCanEditSupplier = ko.observable(UserContext.hasAccess("Admin,Supplier.Edit,Supplier.Delete"));
            this.userCanDeleteSupplier = ko.observable(UserContext.hasAccess("Admin,Supplier.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new SupplierModel());
        }
        Suppliers.prototype.init = function () {
            var self = this;
            $("#page-title").text("Suppliers");
            tools.ajaxGet({
                url: "/Suppliers/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.suppliersLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.suppliersLookupList.GridStructures.SuppliersStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Suppliers.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblSuppliersKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditSupplier()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteSupplier()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.suppliersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Suppliers/GetSuppliers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#suppliers-toolbar-template").html()),
                    columns: columns
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "Supplier",
                    title: "Suppliers",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.suppliersTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.suppliersTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editSupplier(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteSupplierConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        Suppliers.prototype.editSupplier = function (id) {
            var self = this;
            var title = "Add New Supplier";
            if (!isNaN(id)) {
                title = "Edit Supplier";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Supplier Name is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveSupplier(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Suppliers/GetSupplierById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new SupplierModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new SupplierModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'supplier-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        //log.log(parentDropDown);
                    });
                }
            });
        };
        Suppliers.prototype.saveSupplier = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Suppliers/SaveSupplier",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.suppliersTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        Suppliers.prototype.deleteSupplier = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Suppliers/DeleteSupplierConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Supplier deleted successfully");
                    self.suppliersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        Suppliers.prototype.deleteSupplierConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Supplier",
                text: "Are you sure you want to delete Supplier " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteSupplier(id);
            });
        };
        return Suppliers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Suppliers/Index")) {
            log.log("Initialize Suppliers list");
            $(function () {
                (new Suppliers()).init();
            });
        }
    }, 0);
    return Suppliers;
});
//# sourceMappingURL=suppliers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/suppliers/suppliers.js
// module id = 302
// module chunks = 2